import React, {useEffect} from "react";
import {View, Text, StyleSheet, TouchableOpacity} from "react-native";
import {Color, globalFontStyle, globalStyle} from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import FastImage from "../../../common/FastImage";
import {currencyConverter} from "../../../utils/commonMethods";
import FormTextLabel from "../../../commonComponents/FormTextLabel";

const ContestClosedCard = ({contestDetails}) => {
  return (
    <View>
      <View style={[globalStyle.cardContainer, {paddingHorizontal: 0}]}>
        <View
          style={{
            paddingHorizontal: 15,
            paddingBottom: 15,
            borderBottomColor: Colors.borderColor,
            borderBottomWidth: 0.75,
          }}>
          <View style={styles.upperRow}>
            <View style={{flexDirection: "row", flex: 1}}>
              <Text
                style={[
                  globalFontStyle.appFontSubHeading,
                  {color: Colors.black, flexWrap: "wrap"},
                ]}
                numberOfLines={3}>
                {contestDetails?.title} {"\n"}(
                <FormTextLabel
                  labelStyles={[globalFontStyle.appFontBody]}
                  label={"Outcome"}
                />
                -
                <FormTextLabel
                  labelStyles={[
                    globalFontStyle.appFontSubHeading,
                    {
                      color:
                        contestDetails?.outcome === "Y"
                          ? Colors.yesColor
                          : Colors.noColor,
                    },
                  ]}
                  label={contestDetails?.outcome === "Y" ? " Yes" : " No"}
                />
                )
              </Text>
            </View>
          </View>
        </View>
        <View style={{}}>
          {contestDetails?.details?.map((item, index) => {
            return (
              <View
                key={index}
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingHorizontal: 20,
                  marginTop: 15,
                }}>
                <View style={[styles.rowCol, {alignItems: "flex-start"}]}>
                  <FormTextLabel
                    labelStyles={[styles.marginRow, styles.rowValTitle]}
                    label={"Selection"}
                  />
                  <Text style={[styles.rowVal]}>{item?.selection}</Text>
                </View>
                <View style={[styles.rowCol, {alignItems: "flex-start"}]}>
                  <FormTextLabel
                    labelStyles={[styles.marginRow, styles.rowValTitle]}
                    label={"Investment"}
                  />
                  <Text style={[styles.rowVal]}>
                    {item?.totalinvested
                      ? currencyConverter(item?.totalinvested)
                      : "0"}
                  </Text>
                </View>
                <View style={[styles.rowCol, {alignItems: "flex-start"}]}>
                  <FormTextLabel
                    labelStyles={[styles.marginRow, styles.rowValTitle]}
                    label={"Payout"}
                  />
                  <Text style={[styles.rowVal]}>
                    {item?.totalreturn
                      ? currencyConverter(contestDetails?.totalreturn)
                      : "0"}
                  </Text>
                </View>
                <View style={[styles.rowCol, {alignItems: "flex-start"}]}>
                  <FormTextLabel
                    labelStyles={[styles.marginRow, styles.rowValTitle]}
                    label={"Refunds"}
                  />
                  <Text style={[styles.rowVal]}>
                    {item?.totalrefund
                      ? currencyConverter(contestDetails?.totalrefund)
                      : "0"}
                  </Text>
                </View>
              </View>
            );
          })}
        </View>
      </View>
    </View>
  );
};

export default ContestClosedCard;

const styles = StyleSheet.create({
  rowVal: {
    ...globalFontStyle.appFontBody,
    color: Colors.black,
  },
  rowValTitle: {
    ...globalFontStyle.appFontBody,
    color: Colors.lightgrey,
  },
  upperRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  rowCol: {
    flex: 1,
    flexBasis: 0,
    flexShrink: 0,
    alignItems: "center",
  },
  marginRow: {
    marginBottom: 5,
  },
});
